import React from 'react';
import { Container, Paper, Typography, Button, Box, Alert } from '@mui/material';
import { Error, Refresh, Email } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const VerificationFailed = () => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    window.location.href = 'mailto:noreply@salihu.info?subject=Email Verification Issue';
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <Error sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
          <Typography variant="h3" component="h1" gutterBottom color="error.main">
            Email Verification Failed
          </Typography>
        </Box>
        
        <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="h6" gutterBottom>
            We couldn't verify your email address
          </Typography>
          <Typography variant="body2">
            This could happen if the verification link has expired or has already been used.
          </Typography>
        </Alert>
        
        <Typography variant="body1" paragraph>
          Don't worry! Here are some things you can try:
        </Typography>
        
        <Box sx={{ textAlign: 'left', maxWidth: 500, mx: 'auto', mb: 4 }}>
          <Typography variant="body2" component="div" sx={{ mb: 2 }}>
            🔄 <strong>Check your email again</strong> - Look for a more recent verification email<br/>
            ⏰ <strong>Verification links expire</strong> - Links are only valid for 24 hours<br/>
            📧 <strong>Check spam folder</strong> - Sometimes emails end up there<br/>
            🔗 <strong>One-time use</strong> - Each link can only be used once
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mb: 3 }}>
          <Button 
            variant="contained" 
            size="large"
            startIcon={<Refresh />}
            onClick={() => navigate('/login')}
            sx={{ minWidth: 200 }}
          >
            Try Logging In
          </Button>
          <Button 
            variant="outlined" 
            size="large"
            startIcon={<Email />}
            onClick={handleContactSupport}
            sx={{ minWidth: 200 }}
          >
            Contact Support
          </Button>
        </Box>
        
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          If you continue to have issues, please contact our support team and we'll help you get verified.
        </Typography>
      </Paper>
    </Container>
  );
};

export default VerificationFailed;
